<script setup lang="ts">
import type { Locale } from "shared-core/services/i18n.ts";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { getAlternateLocalePath } from "@/utils/seo-utils.ts";

const route = useRoute();
const router = useRouter();

const { locale } = useI18n();

async function switchLocale(): Promise<void> {
  await router.replace(getAlternateLocalePath(route, locale.value as Locale));
}
</script>

<template>
  <button
    class="flex items-center text-2xl leading-none"
    :title="`Change language to ${locale === 'en' ? 'Swedish' : 'English'}`"
    @click="switchLocale"
  >
    {{ locale === "en" ? "🇸🇪" : "🇬🇧" }}
  </button>
</template>

<style scoped lang="css"></style>
